import React, { useContext, useMemo } from "react";
import SikkaInput from "../common/SikkaInput";
// import { Button, Col, Form, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import {
  Col,
  FormGroup,
  Input,
  InputGroupText,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  InputGroup,
} from "reactstrap";
import { useState } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
  Form,
  Tab,
  Tabs,
} from "react-bootstrap";
import { useEffect } from "react";
import ButtonIcon from "../common/ButtonIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCancel,
  faCross,
  faMultiply,
  faPlus,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import PaymentAPIconfigureForm from "./PaymentAPIconfigureForm";
import uuid from "uuid/v1";
import apiCall from "../../services/apiCall";
import AppContext from "../../context/Context";
import Loader from "../common/Loader";
import {
  compareObject,
  customSubString,
  IsValueSame,
} from "../../helpers/utils";
import Divider from "../common/Divider";
import { Switch } from "@mui/material";
import InputMask from "react-input-mask";
import SikkaError from "../common/SikkaError";
import classNames from "classnames";
import SoftBadge from "../common/SoftBadge";
const PaymentApiConfigurationModal = ({
  selectedRow,
  setOpenPaymentApiConfModal,
  AppId,
  setUpdateDataFlag,
}) => {
  const { loginUserDetails, accessToken, isDark } = useContext(AppContext);
  const [twoFactorAuthentication, setTwoFactorAuthentication] = useState(false);
  const [
    originalTwoFactorAuthentication,
    setOriginalTwoFactorAuthentication,
  ] = useState(false);
  const [originalMobileNo, setOriginalMobileNo] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [selectedKey, setSelectedKey] = useState("");
  const [fetchedData, setFetchedData] = useState([]);
  const [TabsData, setTabsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalData, setOriginalData] = useState([]);
  const [defaultUrls, setDefaultUrls] = useState({
    terminal_url: "",
    transaction_api: "",
  });
  const [isSurchargeShow, setIsSurchargeShow] = useState(null);
  const [surchargeValue, setSurchargeValue] = useState("");
  const [surchargeType, setSurchargeType] = useState("$");
  const [responseForSurcharge, setResponseForSurcharge] = useState({});
  const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false);
  const [pricingType, setPricingType] = useState("Surcharge");
  const [originalPricingType, setOriginalPricingType] = useState("");
  const [pricingTypeTouched, setPricingTypeTouched] = useState(false);
  const pricingTypeOptions = ["Surcharge", "Cash Discount", "Dual Pricing"];
  const [insuranceVerification, setInsuranceVerification] = useState(false);
  const [originalInsuranceVerification, setOriginalInsuranceVerification] = useState(false);
  const [insuranceVerificationAutoCheck, setInsuranceVerificationAutoCheck] = useState(false);
  const [originalInsuranceVerificationAutoCheck, setOriginalInsuranceVerificationAutoCheck] = useState(false);

  useMemo(() => {
    if (
      window.location.hostname === "qaapiv4.sikkasoft.com" ||
      window.location.hostname === "localhost"
    ) {
      setDefaultUrls({
        ...defaultUrls,
        terminal_url: "https://test.spinpos.net",
        transaction_api: "https://payment.ipospays.tech/api/v1/iposTransact",
      });
    } else {
      setDefaultUrls({
        ...defaultUrls,
        terminal_url: "https://spinpos.net",
        transaction_api: "https://payment.ipospays.com/api/v1/iposTransact",
      });
    }
  }, []);

  useEffect(() => {
    if (fetchedData.length > 0) {
      setTabsData(fetchedData);

      setSelectedKey(fetchedData[fetchedData.length - 1].id);
    }
  }, [fetchedData]);

  const fetchData = () => {
    let apiParam = {
      app_id: AppId,
      master_customer_id: selectedRow.original.master_customer_id,
    };

    apiCall
      .servertrip(
        "GET",
        "payment_app_api_configuration",
        loginUserDetails,
        apiParam
      )
      .then(
        (res) => {
          const responseData = res.data.items;
          const surchargeStatus =
            res.data?.surcharge_status == "true" ? true : false;
          setIsSurchargeShow(surchargeStatus);
          setResponseForSurcharge(res.data);
          setIsLoading(false);
          setOriginalData(responseData);
          setSurchargeValue(res.data?.surcharge_value);
          setSurchargeType(res.data?.surcharge_type);

          if (res.data?.pricing_type) {
            setPricingType(res.data.pricing_type);
            setOriginalPricingType(res.data.pricing_type);
          } else {
            setPricingType("Surcharge");
            setOriginalPricingType("");
          }

          if (res.data?.status_2fa) {
            setTwoFactorAuthentication(
              res.data?.status_2fa == "false" ? false : true
            );
            setOriginalTwoFactorAuthentication(
              res.data?.status_2fa == "false" ? false : true
            );
          }
          if (res.data?.cell) {
            setMobileNo(res.data?.cell);
            setOriginalMobileNo(res.data?.cell);
          }
          const insVerification =
            `${res.data?.insurance_verification}`.toLowerCase() === "true";
          setInsuranceVerification(insVerification);
          setOriginalInsuranceVerification(insVerification);

          const insVerificationAutoCheck =
            `${res.data?.insurance_verification_auto_check}`.toLowerCase() ===
            "true";
          setInsuranceVerificationAutoCheck(insVerificationAutoCheck);
          setOriginalInsuranceVerificationAutoCheck(insVerificationAutoCheck);
          if (responseData.length > 0) {
            const fillInTabsData = res.data.items.map(
              (fetchedItem, fetchedItemIndex) => {
                let unikID = uuid();

                delete fetchedItem["master_customer_id"];

                return {
                  id: unikID,
                  handleSubmit: () => {},
                  tabTitle: `${fetchedItem.tpn_number}`,
                  TabItemFormData: { ...fetchedItem },
                };
              }
            );
            setFetchedData(fillInTabsData);
          } else {
            setFetchedData([]);
            // const uniqueID = uuid();
            // setPricingType("Surcharge");
            // setOriginalPricingType("");

            let addedTabData = [
              // {
              //   id: `${uniqueID}`,
              //   handleSubmit: () => { },
              //   tabTitle: ` 0000`,
              //   TabItemFormData: {
              //     config_id: `1`,
              //     terminal_url: defaultUrls.terminal_url,
              //     cgi_port: "443/spin",
              //     auth_key: "",
              //     register_id: "",
              //     transaction_api: defaultUrls.transaction_api,
              //     api_token: "",
              //     tpn_number: ``,
              //     command_name: "insert",
              //   },
              // },
            ];

            // setTabsData(addedTabData);
            // setSelectedKey(addedTabData[0].id);
          }
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
          setIsLoading(false);
        }
      );
  };

  useEffect(() => {
    fetchData();
  }, []);
  function formatPhoneNumber(phoneNumber) {
    // Remove non-numeric characters
    var cleaned = phoneNumber.replace(/\D/g, "");

    // Format the number
    var formatted = cleaned.replace(/^(\d{3})(\d{3})(\d{4})$/, "$1$2$3");

    return formatted;
  }

  const AddConfigurePayment = () => {
    const isTwoFactorAuthenticationConfigurationValid = () => {
      if (twoFactorAuthentication) {
        if (!mobileNo.toString().match(/^[^\s]+(\s+[^\s]+)*$/)) {
          toast.warn("Please add moblie number !!");
          return false;
        }
      }
      return true;
    };
    const UpdateInTwoFactor = () => {
      if (twoFactorAuthentication !== originalTwoFactorAuthentication) {
        return true;
      }
      if (twoFactorAuthentication) {
        if (formatPhoneNumber(mobileNo) !== originalMobileNo) {
          return true;
        }
      }
      return false;
    };
    const UpdateInInsuranceVerification = () => {
      if (insuranceVerification !== originalInsuranceVerification) {
        return true;
      }
      if (
        insuranceVerificationAutoCheck !== originalInsuranceVerificationAutoCheck
      ) {
        return true;
      }
      return false;
    };
    // !IsValueSame(responseForSurcharge, {
    //   surcharge_status: `${isSurchargeShow}`,
    //   surcharge_value: `${surchargeValue}`,
    //   surcharge_type: `${surchargeType}`,
    // });
    const UpdateInPricingType = () => {
      if (!originalPricingType) {
        return true;
      }
      if (pricingType !== originalPricingType) {
        return true;
      }
      if (pricingTypeTouched) {
        return true;
      }
      return false;
    };
    const UpdateInSurgeCharge = () => {
      if (
        responseForSurcharge.surcharge_status.toString() !=
        isSurchargeShow.toString()
      ) {
        return true;
      }
      if (isSurchargeShow.toString() == "true") {
        if (
          responseForSurcharge.surcharge_value.toString() !=
          surchargeValue.toString()
        ) {
          return true;
        }
        if (
          responseForSurcharge.surcharge_type.toString() !=
          surchargeType.toString()
        ) {
          return true;
        }
      }
      return false;
    };
    // twofa ==> on || no number=> error
    // twofa ==> off || no number=> APi
    //  twofa ==> on || number=> API
    //this boolean is for validating field
    var twoFactorBool = isTwoFactorAuthenticationConfigurationValid();

    //if changed(true) API should be called else no call
    //if no changed(false) API should be called else no call
    var changeInTwoFactor = UpdateInTwoFactor();
    var changeInPricingType = UpdateInPricingType();
    var changeInInsuranceVerification = UpdateInInsuranceVerification();

    if (twoFactorBool) {
      const FinddeletedConfigureTab = fetchedData.filter((fetchedItem) => {
        let matchFromTabsKeys = TabsData.map((tabItem) => tabItem.id);

        if (!matchFromTabsKeys.includes(fetchedItem.id)) {
          return fetchedItem;
        }
      });

      const deletedItem = FinddeletedConfigureTab.map((deletedItem) => {
        let { TabItemFormData } = deletedItem;
        return { ...TabItemFormData, command_name: "delete" };
      });

      const includeOnlyWithCommand = TabsData.filter((item) => {
        let itemKey = Object.keys(item.TabItemFormData);
        if (itemKey.includes("command_name")) {
          return item;
        }
      }).map((item) => item.TabItemFormData);

      const mergeChanges = [...includeOnlyWithCommand, ...deletedItem].filter(
        (item) => {
          let getItemValues = Object.values(item);
          if (!getItemValues.includes("")) {
            return item;
          }
        }
      );
      const hasNewInsert = mergeChanges.some(
        item => item.command_name === "insert"
      );
      if (hasNewInsert && pricingType && !changeInPricingType) {
        changeInPricingType = true;
      }

      let currentTabItem = TabsData.find((item) => item.id === selectedKey);
      let findDuplicateTpn = (items, findItem) => {
        let DuplicateItem = [];

        items.filter((item) => {
          if (item.TabItemFormData.tpn_number === findItem) {
            DuplicateItem = [...DuplicateItem, item];
          }
        });
        return DuplicateItem;
      };

      const isCheckAnyFeildIsEmpty = TabsData.filter((item) => {
        let getItemValues = Object.values(item.TabItemFormData);

        if (
          (item?.formError
            ? Object.keys(item?.formError).length > 0
            : getItemValues.includes("")) ||
          findDuplicateTpn(TabsData, item.TabItemFormData.tpn_number).length > 1
        ) {
          return item;
        }
      });
      if (isCheckAnyFeildIsEmpty.length > 0) {
        setSelectedKey(
          isCheckAnyFeildIsEmpty[isCheckAnyFeildIsEmpty.length - 1].id
        );
        isCheckAnyFeildIsEmpty[
          isCheckAnyFeildIsEmpty.length - 1
        ].handleSubmit();
      } else {
        const IsSurchargeUpdated = UpdateInSurgeCharge();
        if (
          (mergeChanges.length > 0 || changeInTwoFactor || IsSurchargeUpdated) &&
          pricingType &&
          !changeInPricingType
        ) {
          changeInPricingType = true;
        }

        let body = {
          app_id: AppId,
          master_customer_id: selectedRow.original.master_customer_id,
          add_updated_by: `${loginUserDetails.user_name}`,
          payment_app_api_configuration_child: mergeChanges,
          update_in_2fa: changeInTwoFactor.toString(),
          status_2fa: twoFactorAuthentication.toString(),
          cell: formatPhoneNumber(mobileNo),
          update_in_insurance_verification: changeInInsuranceVerification.toString(),
          insurance_verification: insuranceVerification.toString(),
          insurance_verification_auto_check: insuranceVerificationAutoCheck.toString(),
          update_in_surcharge: `${IsSurchargeUpdated}`,
          update_in_pricing_type: `${changeInPricingType}`,
          surcharge_status: `${isSurchargeShow}`,

          surcharge_value: isSurchargeShow
            ? `${surchargeValue}`
            : responseForSurcharge.surcharge_value,
          surcharge_type: isSurchargeShow
            ? `${surchargeType}`
            : responseForSurcharge.surcharge_type,
            pricing_type: pricingType,
        };

        const bodySurchargeKeys = Object.keys(body)
          .filter((item) => item.includes("surcharge"))
          .filter((item) => {
            if (body[item] == "" && isSurchargeShow) {
              toast.warn(`Please add ${item} !!`);
              return item;
            }
          });

        const isMergeChanges = mergeChanges.length > 0 ? true : false;
        const changeInTwoFactorOrInsurance =
          changeInTwoFactor || changeInInsuranceVerification;
        const ChangesIn2FAandSurchargeAndPricingType = () => {
          const changeInTwoFactor = changeInTwoFactorOrInsurance;
          if (!changeInTwoFactor && !IsSurchargeUpdated && !changeInPricingType) {
            return false;
          }

          if (!changeInTwoFactor && !IsSurchargeUpdated && changeInPricingType) {
            return true;
          }
          if (!changeInTwoFactor && IsSurchargeUpdated && !changeInPricingType) {
            if (bodySurchargeKeys.length < 1) {
              return true;
            } else {
              return false;
            }
          }
          if (changeInTwoFactor && !IsSurchargeUpdated && !changeInPricingType) {
            return true;
          }

          if (changeInTwoFactor && IsSurchargeUpdated && !changeInPricingType) {
            if (bodySurchargeKeys.length < 1) {
              return true;
            } else {
              return false;
            }
          }
          if (changeInTwoFactor && !IsSurchargeUpdated && changeInPricingType) {
            return true;
          }

          if (!changeInTwoFactor && IsSurchargeUpdated && changeInPricingType) {
            if (bodySurchargeKeys.length < 1) {
              return true;
            } else {
              return false;
            }
          }
          if (changeInTwoFactor && IsSurchargeUpdated && changeInPricingType) {
            if (bodySurchargeKeys.length < 1) {
              return true;
            } else {
              return false;
            }
          }
          return false;
        };
        const BodySurchargeValueEmptyOrnot = () => {
          if (bodySurchargeKeys.length < 1) {
            return true;
          } else {
            return false;
          }
        };
        const isBodySurchargeValueEmptyOrnot = BodySurchargeValueEmptyOrnot();
        const isChangesIn2FAandSurchargeAndPricingType = ChangesIn2FAandSurchargeAndPricingType();
        const isMergeAnd2FAandSurchargeandPricingTypeUpdated = () => {
          if (isChangesIn2FAandSurchargeAndPricingType) {
            if (isMergeChanges) {
              return isBodySurchargeValueEmptyOrnot;
            } else {
              return isBodySurchargeValueEmptyOrnot;
            }
          }
          if (isMergeChanges) {
            if (isChangesIn2FAandSurchargeAndPricingType) {
              return isBodySurchargeValueEmptyOrnot;
            } else {
              return isBodySurchargeValueEmptyOrnot;
            }
          }

          return false;
        };
        const isMergeAnd2FAandSurchargeandPricingTypeUpdatedValue = isMergeAnd2FAandSurchargeandPricingTypeUpdated();

        if (isMergeAnd2FAandSurchargeandPricingTypeUpdatedValue) {
          // toast.success("API CALLED...");
          setIsSaveButtonClicked(true);
          apiCall
            .servertrip(
              "POST",
              "payment_app_api_configuration",
              loginUserDetails,
              undefined,
              body
            )
            .then(
              (res) => {
                toast.success(res.data.message);
                setOpenPaymentApiConfModal(false);
                setUpdateDataFlag(true);
              },
              (error) => {
                const resMessage =
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  error.message ||
                  error.toString();
                setIsSaveButtonClicked(false);
                toast.error(resMessage);
              }
            );
        } else {
          if (bodySurchargeKeys.length > 0) {
          } else {
            toast.warn("You have already saved this Payment configuration.");
          }
        }
      }
    }
  };

  useEffect(() => {
    TabsData.map((item) => {
      item.handleSubmit();
    });
  }, [selectedKey]);


  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Row>
            <Col>
              <Row className="d-flex align-items-center custom-navtab-container">
                <Col className="custom-navtab-nav-container">
                  <Nav tabs className="custom-nav-container">
                    {TabsData.map((tabItem) => {
                      return (
                        <>
                          <NavItem key={tabItem.id}>
                            <NavLink
                              className={
                                selectedKey === tabItem.id ? " active" : ""
                              }
                              onClick={() => {
                                setSelectedKey(tabItem.id);
                              }}
                              style={{ cursor: "pointer", fontSize: "13px" }}
                            >
                              TPN{" "}
                              {tabItem?.TabItemFormData.tpn_number
                                ? customSubString(
                                    tabItem?.TabItemFormData.tpn_number,
                                    4,
                                    "end"
                                  ).value
                                : customSubString(tabItem.tabTitle, 4, "end")
                                    .value}
                            </NavLink>
                          </NavItem>
                        </>
                      );
                    })}
                    <NavItem>
                      <NavLink
                        // className={selectedKey === tabIndex ? " active" : ""}
                        className={`border ${
                          isDark ? "text-white" : " border-muted"
                        }`}
                        onClick={() => {
                          const countMaxConfigID =
                            TabsData.length > 0
                              ? Math.max(
                                  ...[...TabsData, ...fetchedData].map((item) =>
                                    parseInt(item.TabItemFormData.config_id)
                                  )
                                ) + 1
                              : fetchData.length > 0
                              ? Math.max(
                                  ...[...fetchedData].map((item) =>
                                    parseInt(item.TabItemFormData.config_id)
                                  )
                                )
                              : TabsData.length + 1;

                          if (TabsData.length < 10) {
                            const uniqueID = uuid();
                            let addedTabData = [
                              ...TabsData,
                              {
                                id: `${uniqueID}`,
                                handleSubmit: () => {},
                                tabTitle: ` 0000`,
                                TabItemFormData: {
                                  config_id: `${countMaxConfigID}`,
                                  terminal_url: defaultUrls.terminal_url,
                                  cgi_port: "443/spin",
                                  auth_key: "",
                                  register_id: "",
                                  transaction_api: defaultUrls.transaction_api,
                                  api_token: "",
                                  tpn_number: ``,
                                  command_name: "insert",
                                  // master_customer_id: "",
                                },
                              },
                            ];
                            setTabsData(addedTabData);
                            setSelectedKey(uniqueID);
                          } else {
                            toast.error("You cannot add more than 10 TPN.");
                          }
                        }}
                        style={{ cursor: "pointer", fontSize: "13px" }}
                      >
                        <FontAwesomeIcon icon={faPlus} /> {" Add TPN"}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Col>
              </Row>

              <TabContent
                className={"PaymentApiConfiguration-form"}
                vertical={false}
                activeTab={selectedKey}
              >
                {TabsData?.map((tabItem, tabIndex) => {
                  return (
                    <>
                      <TabPane tabId={tabItem.id}>
                        <Row>
                          <Col>
                            <PaymentAPIconfigureForm
                              tabItem={tabItem?.tabTitle}
                              selectedRow={selectedRow}
                              formIndex={tabIndex}
                              formId={selectedKey}
                              TabsData={TabsData}
                              setTabsData={setTabsData}
                              defaultFormData={tabItem?.TabItemFormData}
                              formItem={tabItem}
                              fetchedData={originalData}
                              setSelectedKey={setSelectedKey}
                              selectedKey={selectedKey}
                            />
                          </Col>
                        </Row>
                      </TabPane>
                    </>
                  );
                })}
              </TabContent>
            </Col>
          </Row>
          <Row form className="modal-footer bg-light mt-4">
            <Col>
              <Row>
                <Col>
                  <Row>
                    <Col className="">
                      <Label
                        for="twofactorauthentication"
                        className="text-nowrap"
                      >
                        Two-Factor Authentication
                      </Label>

                      <Switch
                        className=""
                        onChange={(checked) => {
                            setTwoFactorAuthentication(
                            checked.target.checked
                          );
                        }}
                        checked={twoFactorAuthentication}
                        height={10}
                      />
                    </Col>
                  </Row>

                  <Row className="mt-2 mb-1">
                    {twoFactorAuthentication ? (
                      <>
                        <Col sm={12} lg={6} md={6}>
                          <Label for={"mobileNo"} className="m-0 text-nowrap">
                            Mobile Number
                          </Label>
                        </Col>

                        <Col sm={12} lg={6} md={6} className="sm-mt-2">
                          <Input
                            type="tel"
                            mask="(999)-999-9999"
                            maskChar=" "
                            size="sm"
                            placeholder="Mobile Number"
                            name="mobileNo"
                            id="mobileNo"
                            onChange={(e) => {
                              const { value } = e.target;
                              setMobileNo(value);
                            }}
                            value={mobileNo}
                            className={classNames("fs--1", {
                              "border-danger": mobileNoError?.message,
                            })}
                            tag={InputMask}
                          />
                          <SikkaError
                            // error={errors["mobileNo"]?.message}
                            className="mt-1"
                          />
                        </Col>
                      </>
                    ) : (
                      <></>
                    )}
                  </Row>
                    <Row className="align-items-center">
                      <Col sm={12} lg={6} md={6}>
                        <Label
                          for="pricing_type"
                          className="m-0 text-nowrap"
                          style={{ minWidth: "auto" }}
                        >
                          Program Type (pricing)
                        </Label>
                      </Col>

                      <Col sm={12} lg={6} md={6} className="sm-mt-2">
                        <Input
                          type="select"
                          name="pricing_type"
                          id="pricing_type"
                          value={pricingType}
                          onChange={(e) => setPricingType(e.target.value)}
                          onClick={() => {
                            setPricingTypeTouched(true);
                          }}
                          size="sm"
                          className="fs--1"
                          style={{ width: "100%", paddingLeft: "5px" }}
                        >
                          {pricingTypeOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </Input>
                      </Col>
                    </Row>

                    <Row className="align-items-center mt-2">
                      <Col sm={12} lg={6} md={6}>
                        <Label
                          for="insurance_verification"
                          className="m-0 text-nowrap"
                        >
                          Insurance Verification
                        </Label>
                      </Col>

                      <Col sm={12} lg={6} md={6} className="sm-mt-2">
                        <Switch
                          className="insurance_verification"
                          onChange={(checked) => {
                            const isChecked1 = checked.target.checked;
                            setInsuranceVerification(isChecked1);
                            setInsuranceVerificationAutoCheck(false);
                          }}
                          checked={insuranceVerification}
                          height={10}
                        />
                      </Col>
                    </Row>
                </Col>
                <Col>
                  <Row>
                    <Col>
                      <Label for="surcharge_status" className="text-nowrap">
                        Surcharge status
                      </Label>

                      <Switch
                        className="surcharge_status"
                        onChange={(checked) => {
                          setIsSurchargeShow(!isSurchargeShow);
                        }}
                        checked={isSurchargeShow}
                        height={10}
                      />
                    </Col>
                  </Row>
                  <Row>
                    {isSurchargeShow && (
                      <>
                        <Col>
                          <InputGroup
                            size="sm"
                            style={{
                              marginTop: "0.5em",
                            }}
                          >
                            <ButtonGroup
                              style={{
                                width: "4.5em",
                                height: "2em",
                              }}
                            >
                              {["$", "%"].map((item) => {
                                return (
                                  <>
                                    <Button
                                      id="btnTeamMemberAccessTypeShow"
                                      className={
                                        item == surchargeType
                                          ? "btn btn-xs btn-success"
                                          : "btn btn-xs btn-secondary"
                                      }
                                      onClick={() => {
                                        setSurchargeType(item);
                                      }}
                                    >
                                      {item}
                                    </Button>
                                  </>
                                );
                              })}
                            </ButtonGroup>
                            <Input
                              type="number"
                              size="sm"
                              placeholder="Surcharge Value"
                              name="surcharge_value"
                              id="surcharge_value"
                              onChange={(e) => {
                                setSurchargeValue(e.target.value);
                              }}
                              value={surchargeValue}
                              // className={classNames("fs--1", {
                              //   "border-danger": mobileNoError?.message,
                              // })}
                            />
                            <SikkaError
                              // error={errors["mobileNo"]?.message}
                              className="mt-1"
                            />
                          </InputGroup>
                        </Col>
                      </>
                    )}
                  </Row>
                  
                {insuranceVerification && (
                  <Row className="align-items-center mt-2">
                    <Col sm={12} lg={6} md={6}>
                      <Label
                        for="insurance_verification_auto_check"
                        className="m-0"
                      >
                        Insurance Verification Auto-Check
                      </Label>
                    </Col>

                    <Col sm={12} lg={6} md={6} className="sm-mt-2">
                      <Switch
                          className="insurance_verification_auto_check"
                          onChange={(checked) => {
                            const isChecked = checked.target.checked;
                            setInsuranceVerificationAutoCheck(isChecked);
                            if (isChecked) {
                              setInsuranceVerification(true);
                            }
                          }}
                        checked={insuranceVerificationAutoCheck}
                        height={10}
                      />
                    </Col>
                  </Row>
                )}
                </Col>
              </Row>
            </Col>

            <Divider className="mt-1" />
            <Col>
              <b>Note :</b>
              <p>
                All your changes will be saved after you click on the save
                button.
              </p>
            </Col>
            <ButtonIcon
              icon={faSave}
              transform="shrink-3 down-2"
              color="outline-success"
              size="sm"
              // className="mx-1 mt-lg-0 mb-2"
              onClick={() => {
                AddConfigurePayment();
              }}
              disabled={isSaveButtonClicked}
            >
              Save
            </ButtonIcon>

            <ButtonIcon
              icon={faCancel}
              transform="shrink-3 down-2"
              color="outline-danger"
              size="sm"
              // className="mx-1 mt-lg-0 mb-2"
              onClick={() => {
                setOpenPaymentApiConfModal(false);
              }}
            >
              Cancel
            </ButtonIcon>
          </Row>
        </>
      )}
    </>
  );
};

export default PaymentApiConfigurationModal;